const startSummary = (
  <div className="internhub-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">What is InternHub?</h3>
      <ul className="list-disc pl-6">
        <li>
          A platform that helps students understand and navigate the software engineering (SWE)
          internship application process
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">
        Overview of the Internship Application Process:
      </h3>
      <ul className="list-disc pl-6">
        <li>Apply with a strong resume</li>
        <li>If selected, receive interview invitations</li>
        <li>Succeed in interviews to secure an internship</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How to use InternHub:</h3>
      <ul className="list-disc pl-6">
        <li>Finish all 15 lessons on the progress tree</li>
        <li>
          As you complete lessons, you'll unlock additional features like:
          <ul className="list-disc pl-6 mt-1">
            <li>Job board</li>
            <li>Interview preparation modules</li>
            <li>Application tracker</li>
          </ul>
        </li>
        <li>You can skip lessons you're already familiar with</li>
        <li>Earn achievements as you progress</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Getting Started:</h3>
      <ul className="list-disc pl-6">
        <li>Begin with the roles and positions lesson</li>
        <li>Click 'Complete Lesson' to progress through the platform</li>
      </ul>
    </div>
  </div>
);

export default startSummary;
